import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const CalendarFilters = ({ filters, onFiltersChange, isExpanded, onToggleExpanded }) => {
  const institutionTypes = [
    { value: 'all', label: 'Tous les établissements' },
    { value: 'university', label: 'Universités publiques' },
    { value: 'private', label: 'Écoles privées' },
    { value: 'engineering', label: 'Écoles d\'ingénieurs' },
    { value: 'business', label: 'Écoles de commerce' },
    { value: 'medical', label: 'Facultés de médecine' },
    { value: 'arts', label: 'Écoles d\'arts' }
  ];

  const programLevels = [
    { value: 'all', label: 'Tous les niveaux' },
    { value: 'license', label: 'Licence' },
    { value: 'master', label: 'Master' },
    { value: 'engineer', label: 'Ingénieur' },
    { value: 'doctorate', label: 'Doctorat' }
  ];

  const regions = [
    { value: 'all', label: 'Toutes les régions' },
    { value: 'casablanca', label: 'Casablanca-Settat' },
    { value: 'rabat', label: 'Rabat-Salé-Kénitra' },
    { value: 'fes', label: 'Fès-Meknès' },
    { value: 'marrakech', label: 'Marrakech-Safi' },
    { value: 'tangier', label: 'Tanger-Tétouan-Al Hoceïma' },
    { value: 'agadir', label: 'Souss-Massa' }
  ];

  const eventTypes = [
    { key: 'applications', label: 'Candidatures', color: 'bg-blue-500' },
    { key: 'exams', label: 'Concours', color: 'bg-red-500' },
    { key: 'results', label: 'Résultats', color: 'bg-green-500' },
    { key: 'interviews', label: 'Entretiens', color: 'bg-purple-500' },
    { key: 'registration', label: 'Inscriptions', color: 'bg-orange-500' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const handleEventTypeToggle = (eventType) => {
    const newEventTypes = filters?.eventTypes?.includes(eventType)
      ? filters?.eventTypes?.filter(type => type !== eventType)
      : [...filters?.eventTypes, eventType];

    handleFilterChange('eventTypes', newEventTypes);
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-soft">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="font-medium text-foreground">Filtres</h3>
        <button
          onClick={onToggleExpanded}
          className="p-1 hover:bg-muted rounded transition-smooth lg:hidden"
        >
          <Icon
            name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            size={20}
          />
        </button>
      </div>
      <div className={`p-4 space-y-4 ${isExpanded ? 'block' : 'hidden lg:block'}`}>

        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Types d'événements
          </label>
          <div className="space-y-2">
            {eventTypes?.map((eventType) => (
              <div key={eventType?.key} className="flex items-center space-x-3">
                <Checkbox
                  checked={filters?.eventTypes?.includes(eventType?.key)}
                  onChange={() => handleEventTypeToggle(eventType?.key)}
                />
                <div className="flex items-center space-x-2">
                  <div className={`w-3 h-3 rounded-full ${eventType?.color}`} />
                  <span className="text-sm text-foreground">{eventType?.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-2 border-t border-border">
          <Checkbox
            label="Afficher uniquement mes établissements favoris"
            checked={filters?.favoritesOnly}
            onChange={(e) => handleFilterChange('favoritesOnly', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarFilters;